<template>
  <svg
    width="160"
    height="160"
    viewBox="0 0 160 160"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.06"
      d="M80 140C113.137 140 140 113.137 140 80C140 46.8629 113.137 20 80 20C46.8629 20 20 46.8629 20 80C20 113.137 46.8629 140 80 140Z"
      fill="url(#paint0_linear_10083_72768)"
    />
    <path
      d="M127.104 66.6558V121.344C127.104 123.349 125.305 125 123.119 125H38.0901C35.9044 125 34.1045 123.349 34.1045 121.344V66.6558C34.1045 64.651 35.9044 63 38.0901 63H123.119C125.305 63 127.104 64.651 127.104 66.6558Z"
      fill="url(#paint1_linear_10083_72768)"
    />
    <rect
      opacity="0.04"
      x="62.6572"
      y="71.9736"
      width="62"
      height="49.7632"
      rx="1.77143"
      fill="url(#paint2_linear_10083_72768)"
    />
    <path
      d="M81.3937 105.007L85.1496 101.108C85.4271 100.82 85.7921 100.662 86.1636 100.633C86.4325 100.613 86.7073 100.541 86.8944 100.347L87.033 100.203C87.3063 99.9194 87.3261 99.4799 87.1106 99.1502C84.9405 95.8311 85.2876 91.2688 88.111 88.3382C90.615 85.7392 94.3468 85.1644 97.3804 86.6389C98.2231 87.0387 99.0176 87.6135 99.7399 88.3382C100.631 89.2379 101.257 90.3125 101.642 91.462C101.835 92.0118 101.979 92.5616 102.051 93.1364C102.412 95.7104 101.642 98.4344 99.7399 100.409C99.6918 100.459 99.6677 100.484 99.6195 100.534C98.0305 102.133 95.984 102.908 93.9134 102.908C92.3173 102.908 90.7211 102.432 89.3487 101.482C89.0065 101.244 88.5371 101.266 88.2482 101.566L88.1284 101.69C87.9512 101.874 87.8853 102.133 87.873 102.388C87.8538 102.788 87.7004 103.184 87.4128 103.483L83.6809 107.381C83.055 108.031 82.0438 108.031 81.4178 107.381C80.7677 106.731 80.7677 105.657 81.3937 105.007ZM89.2908 99.1841C89.5797 99.484 89.8927 99.7339 90.2057 99.9838C90.5186 100.209 90.8316 100.384 91.1446 100.534C92.8781 101.383 94.9246 101.383 96.6581 100.534C97.3323 100.209 97.9583 99.7589 98.512 99.1841C100.101 97.5348 100.703 95.2606 100.318 93.1364C100.221 92.5616 100.053 91.9869 99.7881 91.462C99.4751 90.7873 99.0417 90.1375 98.512 89.5878C98.1509 89.2129 97.7656 88.888 97.3564 88.6381C96.297 87.9384 95.0932 87.6135 93.8893 87.6135C92.204 87.6135 90.5427 88.2633 89.2667 89.5878C86.7387 92.2368 86.7387 96.5351 89.2908 99.1841Z"
      fill="#7FBAFE"
    />
    <path
      opacity="0.16"
      d="M35.7363 74.6308C35.7363 73.1633 36.926 71.9736 38.3935 71.9736H55.9213C57.3888 71.9736 58.5784 73.1633 58.5784 74.6308V119.08C58.5784 120.547 57.3888 121.737 55.9213 121.737H38.3935C36.926 121.737 35.7363 120.547 35.7363 119.08V74.6308Z"
      fill="url(#paint3_linear_10083_72768)"
    />
    <path
      d="M39.3691 77.6836H52.017"
      stroke="#F2F4F7"
      stroke-width="1.77143"
      stroke-miterlimit="10"
    />
    <path
      d="M39.3691 84.0073H49.6456"
      stroke="#F2F4F7"
      stroke-width="1.77143"
      stroke-miterlimit="10"
    />
    <path
      d="M39.3691 90.3313H52.8075"
      stroke="#F2F4F7"
      stroke-width="1.77143"
      stroke-miterlimit="10"
    />
    <path
      d="M39.3691 96.6553H44.9026"
      stroke="#F2F4F7"
      stroke-width="1.77143"
      stroke-miterlimit="10"
    />
    <path
      d="M39.3691 102.979H50.4361"
      stroke="#F2F4F7"
      stroke-width="1.77143"
      stroke-miterlimit="10"
    />
    <path
      d="M39.3691 109.303H46.4836"
      stroke="#F2F4F7"
      stroke-width="1.77143"
      stroke-miterlimit="10"
    />
    <path
      opacity="0.6"
      d="M127.056 66.9864V69.8797H34.1045V66.9864C34.1045 64.8003 35.9035 63 38.088 63H123.072C125.257 63 127.056 64.8003 127.056 66.9864Z"
      fill="url(#paint4_linear_10083_72768)"
    />
    <path
      d="M38.2808 67.6937C38.955 67.6937 39.5016 67.1468 39.5016 66.4721C39.5016 65.7974 38.955 65.2505 38.2808 65.2505C37.6066 65.2505 37.0601 65.7974 37.0601 66.4721C37.0601 67.1468 37.6066 67.6937 38.2808 67.6937Z"
      fill="#EAEEF9"
    />
    <path
      opacity="0.6"
      d="M42.0713 67.6937C42.7455 67.6937 43.2921 67.1468 43.2921 66.4721C43.2921 65.7974 42.7455 65.2505 42.0713 65.2505C41.3971 65.2505 40.8506 65.7974 40.8506 66.4721C40.8506 67.1468 41.3971 67.6937 42.0713 67.6937Z"
      fill="#EAEEF9"
    />
    <path
      opacity="0.4"
      d="M45.9268 67.6937C46.601 67.6937 47.1476 67.1468 47.1476 66.4721C47.1476 65.7974 46.601 65.2505 45.9268 65.2505C45.2526 65.2505 44.7061 65.7974 44.7061 66.4721C44.7061 67.1468 45.2526 67.6937 45.9268 67.6937Z"
      fill="#EAEEF9"
    />
    <g filter="url(#filter0_d_10083_72768)">
      <path
        d="M131.604 55.0096V114.99C131.604 117.189 129.63 119 127.233 119H33.9758C31.5786 119 29.6045 117.189 29.6045 114.99V55.0096C29.6045 52.8108 31.5786 51 33.9758 51H127.233C129.63 51 131.604 52.8108 131.604 55.0096Z"
        fill="url(#paint5_linear_10083_72768)"
      />
    </g>
    <rect
      opacity="0.04"
      x="60.9204"
      y="60.842"
      width="68"
      height="54.5789"
      rx="1.94286"
      fill="url(#paint6_linear_10083_72768)"
    />
    <path
      d="M81.4702 97.0721L85.5896 92.7962C85.894 92.4803 86.2943 92.3066 86.7017 92.2752C86.9966 92.2525 87.298 92.1741 87.5032 91.9612L87.6553 91.8033C87.955 91.4922 87.9767 91.0102 87.7403 90.6486C85.3603 87.0082 85.7409 82.0045 88.8376 78.7902C91.5838 75.9397 95.6768 75.3093 99.004 76.9264C99.9283 77.365 100.8 77.9954 101.592 78.7902C102.569 79.777 103.255 80.9556 103.678 82.2164C103.889 82.8194 104.048 83.4224 104.127 84.0528C104.523 86.8759 103.678 89.8635 101.592 92.0288C101.539 92.0836 101.513 92.111 101.46 92.1658C99.717 93.92 97.4725 94.7697 95.2015 94.7697C93.4509 94.7697 91.7003 94.2483 90.195 93.2055C89.8197 92.9454 89.3049 92.969 88.9881 93.2979L88.8566 93.4343C88.6623 93.636 88.59 93.92 88.5765 94.1998C88.5554 94.6384 88.3872 95.0727 88.0718 95.4001L83.9788 99.6759C83.2922 100.389 82.1832 100.389 81.4966 99.6759C80.7836 98.9633 80.7836 97.7847 81.4702 97.0721ZM90.1315 90.6858C90.4484 91.0147 90.7916 91.2888 91.1349 91.5628C91.4782 91.8095 91.8215 92.0014 92.1648 92.1658C94.066 93.0977 96.3106 93.0977 98.2118 92.1658C98.9512 91.8095 99.6378 91.3162 100.245 90.6858C101.988 88.8768 102.648 86.3825 102.226 84.0528C102.12 83.4224 101.935 82.792 101.645 82.2164C101.301 81.4763 100.826 80.7637 100.245 80.1607C99.849 79.7496 99.4265 79.3932 98.9776 79.1192C97.8157 78.3517 96.4954 77.9954 95.1751 77.9954C93.3267 77.9954 91.5046 78.708 90.1051 80.1607C87.3324 83.066 87.3324 87.7804 90.1315 90.6858Z"
      fill="#7FBAFE"
    />
    <path
      opacity="0.16"
      d="M31.394 63.7563C31.394 62.1468 32.6988 60.842 34.3083 60.842H53.5324C55.1419 60.842 56.4467 62.1468 56.4467 63.7563V112.507C56.4467 114.116 55.1419 115.421 53.5324 115.421H34.3083C32.6988 115.421 31.394 114.116 31.394 112.507V63.7563Z"
      fill="url(#paint7_linear_10083_72768)"
    />
    <path
      d="M35.3789 67.1045H49.2508"
      stroke="#F2F4F7"
      stroke-width="1.94286"
      stroke-miterlimit="10"
    />
    <path
      d="M35.3789 74.0403H46.6498"
      stroke="#F2F4F7"
      stroke-width="1.94286"
      stroke-miterlimit="10"
    />
    <path
      d="M35.3789 80.9763H50.1178"
      stroke="#F2F4F7"
      stroke-width="1.94286"
      stroke-miterlimit="10"
    />
    <path
      d="M35.3789 87.9121H41.4479"
      stroke="#F2F4F7"
      stroke-width="1.94286"
      stroke-miterlimit="10"
    />
    <path
      d="M35.3789 94.8484H47.5168"
      stroke="#F2F4F7"
      stroke-width="1.94286"
      stroke-miterlimit="10"
    />
    <path
      d="M35.3789 101.784H43.1818"
      stroke="#F2F4F7"
      stroke-width="1.94286"
      stroke-miterlimit="10"
    />
    <path
      opacity="0.6"
      d="M131.551 55.3721V58.5455H29.6045V55.3721C29.6045 52.9745 31.5776 51 33.9735 51H127.182C129.578 51 131.551 52.9745 131.551 55.3721Z"
      fill="url(#paint8_linear_10083_72768)"
    />
    <path
      d="M34.1846 56.148C34.924 56.148 35.5235 55.5481 35.5235 54.8081C35.5235 54.0681 34.924 53.4683 34.1846 53.4683C33.4451 53.4683 32.8457 54.0681 32.8457 54.8081C32.8457 55.5481 33.4451 56.148 34.1846 56.148Z"
      fill="#EAEEF9"
    />
    <path
      opacity="0.6"
      d="M38.3423 56.148C39.0818 56.148 39.6812 55.5481 39.6812 54.8081C39.6812 54.0681 39.0818 53.4683 38.3423 53.4683C37.6029 53.4683 37.0034 54.0681 37.0034 54.8081C37.0034 55.5481 37.6029 56.148 38.3423 56.148Z"
      fill="#EAEEF9"
    />
    <path
      opacity="0.4"
      d="M42.5708 56.148C43.3103 56.148 43.9097 55.5481 43.9097 54.8081C43.9097 54.0681 43.3103 53.4683 42.5708 53.4683C41.8314 53.4683 41.2319 54.0681 41.2319 54.8081C41.2319 55.5481 41.8314 56.148 42.5708 56.148Z"
      fill="#EAEEF9"
    />
    <g filter="url(#filter1_d_10083_72768)">
      <path
        d="M137.604 40.4813V107.519C137.604 109.976 135.398 112 132.719 112H28.4901C25.8109 112 23.6045 109.976 23.6045 107.519V40.4813C23.6045 38.0238 25.8109 36 28.4901 36H132.719C135.398 36 137.604 38.0238 137.604 40.4813Z"
        fill="url(#paint9_linear_10083_72768)"
      />
    </g>
    <rect
      opacity="0.04"
      x="58.6045"
      y="47"
      width="76"
      height="61"
      rx="2"
      fill="url(#paint10_linear_10083_72768)"
    />
    <path
      opacity="0.4"
      d="M105.814 77.7373C105.814 74.8795 103.719 72.5457 101.052 72.3362C101.125 72.0743 101.171 71.8124 101.2 71.5351C101.564 68.3939 99.25 66.3126 96.7774 65.1049C96.0934 64.786 95.2939 64.3639 94.5513 64.2329C94.5806 64.3639 95.5727 67.0814 92.5533 69.1318C91.4502 69.9499 90.7831 71.0991 90.5798 72.3208C87.87 72.4856 85.7024 74.8504 85.7024 77.7373C85.7024 77.9426 85.7291 78.1331 85.7577 78.3378L85.7594 78.3504C85.7594 78.3796 85.7733 78.4245 85.7733 78.4552C83.3624 78.9189 81.5229 81.1172 81.5229 83.7809C81.5229 86.7726 83.8615 88.6275 86.7007 89.2112C92.5625 90.0939 102.918 89.7952 105.301 89.2112C107.74 88.5982 110.023 86.7726 110.023 83.7809C110.023 81.1035 108.182 78.9034 105.757 78.4552C105.786 78.2148 105.814 77.9761 105.814 77.7373Z"
      stroke="#66ACFF"
      stroke-width="2.375"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M91.9541 77.467V77.482"
      stroke="#66ACFF"
      stroke-width="2.375"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M99.6694 77.467V77.482"
      stroke="#66ACFF"
      stroke-width="2.375"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M93.2622 84.1052C93.894 83.3903 94.7181 82.8757 95.7887 82.865C96.9072 82.8528 97.7114 83.3827 98.383 84.1052"
      stroke="#66ACFF"
      stroke-width="2.375"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      opacity="0.16"
      d="M25.6045 50C25.6045 48.3431 26.9476 47 28.6045 47H50.6045C52.2613 47 53.6045 48.3431 53.6045 50V105C53.6045 106.657 52.2613 108 50.6045 108H28.6045C26.9476 108 25.6045 106.657 25.6045 105V50Z"
      fill="url(#paint11_linear_10083_72768)"
    />
    <path
      d="M30.0581 53.999H45.562"
      stroke="#F2F4F7"
      stroke-width="2"
      stroke-miterlimit="10"
    />
    <path
      d="M30.0581 61.751H42.655"
      stroke="#F2F4F7"
      stroke-width="2"
      stroke-miterlimit="10"
    />
    <path
      d="M30.0581 69.5029H46.531"
      stroke="#F2F4F7"
      stroke-width="2"
      stroke-miterlimit="10"
    />
    <path
      d="M30.0581 77.2549H36.8411"
      stroke="#F2F4F7"
      stroke-width="2"
      stroke-miterlimit="10"
    />
    <path
      d="M30.0581 85.0068H43.624"
      stroke="#F2F4F7"
      stroke-width="2"
      stroke-miterlimit="10"
    />
    <path
      d="M30.0581 92.7588H38.779"
      stroke="#F2F4F7"
      stroke-width="2"
      stroke-miterlimit="10"
    />
    <path
      opacity="0.6"
      d="M137.545 40.8865V44.4332H23.6045V40.8865C23.6045 38.2068 25.8097 36 28.4875 36H132.662C135.339 36 137.545 38.2068 137.545 40.8865Z"
      fill="url(#paint12_linear_10083_72768)"
    />
    <path
      d="M28.7235 41.7535C29.5499 41.7535 30.2199 41.0831 30.2199 40.256C30.2199 39.429 29.5499 38.7585 28.7235 38.7585C27.897 38.7585 27.2271 39.429 27.2271 40.256C27.2271 41.0831 27.897 41.7535 28.7235 41.7535Z"
      fill="#EAEEF9"
    />
    <path
      opacity="0.6"
      d="M33.3704 41.7535C34.1969 41.7535 34.8668 41.0831 34.8668 40.256C34.8668 39.429 34.1969 38.7585 33.3704 38.7585C32.544 38.7585 31.874 39.429 31.874 40.256C31.874 41.0831 32.544 41.7535 33.3704 41.7535Z"
      fill="#EAEEF9"
    />
    <path
      opacity="0.4"
      d="M38.096 41.7535C38.9225 41.7535 39.5924 41.0831 39.5924 40.256C39.5924 39.429 38.9225 38.7585 38.096 38.7585C37.2696 38.7585 36.5996 39.429 36.5996 40.256C36.5996 41.0831 37.2696 41.7535 38.096 41.7535Z"
      fill="#EAEEF9"
    />
    <defs>
      <filter
        id="filter0_d_10083_72768"
        x="8.23306"
        y="40.3143"
        width="144.743"
        height="110.743"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="10.6857" />
        <feGaussianBlur stdDeviation="10.6857" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.0117647 0 0 0 0 0.466667 0 0 0 0 1 0 0 0 0.16 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_10083_72768"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_10083_72768"
          result="shape"
        />
      </filter>
      <filter
        id="filter1_d_10083_72768"
        x="1.60449"
        y="25"
        width="158"
        height="120"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="11" />
        <feGaussianBlur stdDeviation="11" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.0117647 0 0 0 0 0.466667 0 0 0 0 1 0 0 0 0.16 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_10083_72768"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_10083_72768"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_10083_72768"
        x1="19.9981"
        y1="139.999"
        x2="139.999"
        y2="19.9985"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#006FFF" />
        <stop offset="1" stop-color="#0683FF" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_10083_72768"
        x1="80.5742"
        y1="61.5659"
        x2="80.5742"
        y2="125.668"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FDFEFF" />
        <stop offset="0.9964" stop-color="#ECF0F5" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_10083_72768"
        x1="62.6563"
        y1="121.736"
        x2="111.241"
        y2="61.205"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#006FFF" />
        <stop offset="1" stop-color="#0683FF" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_10083_72768"
        x1="35.736"
        y1="121.736"
        x2="73.47"
        y2="104.416"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#006FFF" />
        <stop offset="1" stop-color="#0683FF" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_10083_72768"
        x1="34.103"
        y1="69.8796"
        x2="35.1159"
        y2="56.1952"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#006FFF" />
        <stop offset="1" stop-color="#0683FF" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_10083_72768"
        x1="80.5713"
        y1="49.4271"
        x2="80.5713"
        y2="119.733"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FDFEFF" />
        <stop offset="0.9964" stop-color="#ECF0F5" />
      </linearGradient>
      <linearGradient
        id="paint6_linear_10083_72768"
        x1="60.9194"
        y1="115.421"
        x2="114.205"
        y2="49.0313"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#006FFF" />
        <stop offset="1" stop-color="#0683FF" />
      </linearGradient>
      <linearGradient
        id="paint7_linear_10083_72768"
        x1="31.3937"
        y1="115.421"
        x2="72.7794"
        y2="96.4239"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#006FFF" />
        <stop offset="1" stop-color="#0683FF" />
      </linearGradient>
      <linearGradient
        id="paint8_linear_10083_72768"
        x1="29.6029"
        y1="58.5454"
        x2="30.7138"
        y2="43.5367"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#006FFF" />
        <stop offset="1" stop-color="#0683FF" />
      </linearGradient>
      <linearGradient
        id="paint9_linear_10083_72768"
        x1="80.5673"
        y1="34.242"
        x2="80.5673"
        y2="112.819"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FDFEFF" />
        <stop offset="0.9964" stop-color="#ECF0F5" />
      </linearGradient>
      <linearGradient
        id="paint10_linear_10083_72768"
        x1="58.6033"
        y1="108"
        x2="118.158"
        y2="33.7998"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#006FFF" />
        <stop offset="1" stop-color="#0683FF" />
      </linearGradient>
      <linearGradient
        id="paint11_linear_10083_72768"
        x1="25.6041"
        y1="108"
        x2="71.8587"
        y2="86.7679"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#006FFF" />
        <stop offset="1" stop-color="#0683FF" />
      </linearGradient>
      <linearGradient
        id="paint12_linear_10083_72768"
        x1="23.6027"
        y1="44.4331"
        x2="24.8443"
        y2="27.6586"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#006FFF" />
        <stop offset="1" stop-color="#0683FF" />
      </linearGradient>
    </defs>
  </svg>
</template>

<script setup></script>
